<template>
  <v-container :fluid="true" class="page_container">
    <div class="feedback__title">
      <span class="feedback__title--text">
        ОБРАЩЕНИЯ
      </span>
      <span class="btn_send_feedback" @click="clickSendFeedbackDialog" v-if="$vuetify.display.width > 768">
          оставить обращение
      </span>
      <v-icon size="20" v-else color="#34347C" @click="clickSendFeedbackDialog">mode_comment</v-icon>
    </div>
    <div
        class="feedback__content"
    >
      <v-lazy
          v-if="!isLoadingFeedbacks && items.length > 0"
          v-model="activeFaq"
          :options="{
              threshold: .5
          }"
          class="lazy-faq"
          transition="fade-transition"
      >
        <v-expansion-panels variant="accordion">
          <v-expansion-panel
              elevation="0"
              v-for="(item, index) in items"
              :key="`question_${index}`"
          >
            <v-expansion-panel-title hide-actions @click="loadDetail(item)">
              <template v-slot:default="props">
                <v-row no-gutters class="feedback__title_row">
                  <v-icon :size="`${$vuetify.display.xs ? '20' : '25'}`" :class="`${!props.expanded ? 'expand-icon' : 'collapse-icon'}`">$custom_arrow_sm_down</v-icon>
                  {{ item.theme }}
                </v-row>
                <v-row no-gutters justify="start" class="feedback__title_row--second">
                  <div class="d-flex" :class="$vuetify.display.width < 450 ? 'flex-wrap' : ''" v-if="item.ended === null">
                    <v-chip class="feedback__chip open" :class="$vuetify.display.width < 450 ? 'mb-3' : ''">Открыто</v-chip>
                    <div class="feedback__create_date">Создано: {{ displayDate(item.created, $vuetify.display.width >= 1280) }}</div>
                  </div>
                  <div class="d-flex" :class="$vuetify.display.width < 450 ? 'flex-wrap' : ''" v-else>
                    <v-chip class="feedback__chip close" :class="$vuetify.display.width < 450 ? 'mb-3' : ''">Закрыто</v-chip>
                    <div class="feedback__create_date">Решено: {{ displayDate(item.created, $vuetify.display.width >= 1280) }}</div>
                  </div>
                </v-row>
              </template>
            </v-expansion-panel-title>
            <v-expansion-panel-text>
              <div v-if="!isLoadingFeedbackDetail && getFeedbackDetail">
                <p class="open_panel_text_title">Текст обращения:</p>
                <p class="mb-5" style="overflow: hidden">{{ getFeedbackDetail.text }}</p>
                <p class="open_panel_text_title mb-2" v-if="getFeedbackDetail.files.length > 0">Прикрепленные файлы:</p>
                <div
                    class="mb-2"
                    v-for="dock in getFeedbackDetail.files"
                    :key="dock.name"
                >
                  <a
                     class="feedback_files_text"
                     :href="getFileLink(dock.file.link)"
                     target="_blank"
                     @click.stop
                  >
                    <v-icon size="40" class="mr-2">$custom_dock</v-icon>
                    {{ dock.name }}
                  </a>
                </div>
                <p class="open_panel_text_title--blue" v-if="getFeedbackDetail.comment">Ответ:</p>
                <p class="open_panel_text_title--blue text-black mt-0" style="overflow: hidden" v-if="getFeedbackDetail.comment" v-html="getFeedbackDetail.comment"> </p>
              </div>
              <div v-else>
                <v-row no-gutters justify="center" align="center" style="min-height: 60px;">
                  <fulfilling-square-spinner
                      :animation-duration="4000"
                      :size="50"
                      color="#34347C"
                  />
                </v-row>
              </div>
            </v-expansion-panel-text>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-lazy>
      <div v-else-if="!isLoadingFeedbacks && items.length === 0">
        <NoData
          :text="'Список обращений пуст'"
        />
      </div>
      <div v-else>
        <v-row no-gutters justify="center" align="center" style="height: 25vh; min-height: 200px">
          <fulfilling-square-spinner
              :animation-duration="4000"
              :size="100"
              color="#34347C"
          />
        </v-row>
      </div>
    </div>

    <send-feedback-dialog
        v-if="feedback_dialog"
        v-model="feedback_dialog"
        @save="acceptSendFeedbackDialog"
        @close="feedback_dialog=false"
    />
  </v-container>
</template>

<script>
import { defineComponent } from 'vue'
import names from "@/modules/core/routers/names"
import { mapActions, mapGetters } from "vuex"
import PaginatedDataMapperMixin from "@/mixins/PaginatedDataMapperMixin"
import { FulfillingSquareSpinner } from "epic-spinners"
import { displayDate } from "@/helper"
import NoData from "@/modules/templates/NoData.vue"
import SendFeedbackDialog from "@/modules/personal_account/feedbacks/modals/SendFeedbackDialog.vue"
import helper from "@/urls/helper"

export default defineComponent({
  name: "Feedbacks",
  components: { SendFeedbackDialog, NoData, FulfillingSquareSpinner },
  mixins: [PaginatedDataMapperMixin],
  data () {
    return {
      activeFaq: false,
      feedback_dialog: false,
      oldValue: undefined,
    }
  },
  computed: {
    names: () => names,
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
      items: 'personal_account/feedbacks/getFeedbacks',
      isLoadingFeedbacks: 'personal_account/feedbacks/isLoadingFeedbacks',
      isLoadingFeedbackDetail: 'personal_account/feedbacks/isLoadingFeedbackDetail',
      getFeedbackDetail: 'personal_account/feedbacks/getFeedbackDetail',
    }),
  },
  watch: {

  },
  methods: {
    displayDate: displayDate,
    ...mapActions({
      loadFeedbacks: 'personal_account/feedbacks/loadFeedbacks',
      loadFeedbackDetail: 'personal_account/feedbacks/loadFeedbackDetail',
    }),
    getFileLink (url) {
      return helper.getMendeleevUrlWithParameters(url.basename, url.action, url.params, url.get_params)
    },
    acceptSendFeedbackDialog () {
      this.feedback_dialog = false
      this.loadData()
    },
    clickSendFeedbackDialog () {
      this.feedback_dialog = true
    },
    loadData (url = undefined) {
      this.loadFeedbacks({
        url: url,
        urlAppend: (url) => {
          return this.addPageParameter(this.addSizeParameter(url))
        },
        finalizer: (data, url) => {
          this.setCurrentLoadUrl(url)
        },
        catcher: () => {}
      })
    },
    loadDetail (item) {
      if (this.oldValue !== item) {
        this.loadFeedbackDetail({
          id: item.id,
          finalizer: () => {
            this.oldValue = item
          },
          catcher: () => {}
        })
      }
    },
  },
  created () {
    if (!this.isAuthenticated) {
      this.$router.push({ name: names.MAIN })
    } else {
      this.loadData()
    }
  }
})
</script>

<style scoped lang="scss">
.feedback__title {
  display: flex;
  justify-content: space-between;
}

.feedback__title--text {
  padding: 0;
  margin-bottom: 30px;
  text-transform: uppercase;
  font-size: 20px;
  font-weight: 700;
  color: #34347C;
  text-align: left;

  &::before {
    margin-right: 28px;
    content: "";
    display: inline-block;
    width: 14px;
    height: 14px;
    background-color: #376FFE;
  }
}

.btn_send_feedback {
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  height: 30px;
  padding: 0 10px;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  text-transform: uppercase;
  color: #3254B9;
  border: 1px solid #3254B9;
  border-radius: 10px;

  &:hover {
    background-color: #3254B9;
    color: #FFFFFF;
  }

  &.click {
    background-color: #3254B9;
    color: #FFFFFF;
  }
}

.feedback__content {
  border-radius: 5px;
  width: 100%;
  background-color: white;
  padding: 50px;

  flex-direction: column;
  margin: auto;
  display: flex;
  z-index: 2;
}

.v-expansion-panel {
  border-radius: 0 !important;
  background-color: transparent;
}

.v-expansion-panel-title {
  flex-wrap: wrap;
  min-height: 130px;
  border-bottom: none;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
  color: #313743;
  justify-content: flex-start;
}

.v-expansion-panel-text {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  text-align: start;
  padding-left: 55px;
  color: #313743;
}

.v-expansion-panel:not(:first-child)::after {
  border-color: #313743 !important;
}

.v-expansion-panel:last-child {
  border-bottom: 1px solid #313743;
}

.expand-icon {
  transition: all .3s;
  margin-right: 30px;
  margin-left: 0;
}

.collapse-icon {
  transform: rotate(180deg);
  transition: all .3s;
  margin-right: 30px;
}

.feedback__title_row {
  flex-wrap: nowrap;
  width: 100% !important;

  &--second {
    margin: 30px 0 14px 0;
    padding-left: 55px;
  }
}

.feedback__chip {
  min-width: 78px !important;
  margin-right: 30px;
  border-radius: 50px;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 15px;
  text-align: center;
  color: #FFFFFF;

  &.open {
    background-color: #39B54A;
  }

  &.close {
    background-color: #313743;
  }
}

.feedback__create_date {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 30px;
  color: #959595;
}

.open_panel_text_title {
  color: #313743;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;

  &--blue {
    color: #3254B9;
    padding-left: 40px;
    margin-top: 50px;
  }
}

.feedback_files_text {
  text-decoration: none;
  color: #313743;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

@media screen and (max-width: 768px) {
  .feedback__title {
    margin-top: 20px;
  }

  .feedback__content {
    padding: 20px;
  }

  .feedback__title--text {
    margin-bottom: 20px;
    font-size: 14px;
    line-height: 17px;

    &::before {
      margin-right: 20px;
      width: 10px;
      height: 10px;
    }
  }

  .v-expansion-panel-title {
    font-size: 16px;
    line-height: 20px;
    padding: 0;
  }

  .feedback__title_row {
    &--second {
      margin: 10px 0;
      padding-left: 40px;
    }
  }

  .expand-icon {
    margin-right: 20px;
  }

  .collapse-icon {
    margin-right: 20px;
  }

  .v-expansion-panel-text {
    font-size: 14px;
    line-height: 17px;
    padding-left: 16px;
  }

  .open_panel_text_title {
    &--blue {
      color: #3254B9;
      padding-left: 20px;
      margin-top: 30px;
    }
  }
}

@media screen and (max-width: 369px) {
  .v-expansion-panel-title {
    font-size: 13px;
    line-height: 17px;
  }

  .open_panel_text_title {
    &--blue {
      color: #3254B9;
      padding-left: 0;
      margin-top: 20px;
    }
  }
}
</style>
